<template>
  <div class="ltv-analysis-table-cont">
    <t-enhanced-table
      ref="table"
      row-key="date"
      :columns="columns"
      :data="data"
      table-layout="auto"
      stripe
      :tree="{ treeNodeColumnIndex: 0 }"
    ></t-enhanced-table>
  </div>
</template>

<script>
import lodash from 'lodash';
import numeral from 'numeral';
import { CaretDownSmallIcon, CaretRightSmallIcon } from 'tdesign-icons-vue';
import dayjs from 'dayjs';
import XLSX from 'xlsx';

export default {
  name: 'DataTable',
  components: {},
  props: {
    analysisConfig: {
      type: Object,
      default: () => ({}),
    },
    analysisData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columns: [],
      data: [],

      pagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        total: 0,
      },
    };
  },
  watch: {
    analysisData: {
      handler() {
        this.setCurrentData();
      },
      deep: true,
    },
  },
  mounted() {
    this.setCurrentData();
  },
  methods: {
    setCurrentData() {
      this.columns = this.generatedColumn();
      this.data = this.translateAnalysisData();
    },
    translateAnalysisData() {
      if (!this.analysisData || !this.analysisData.dataList) {
        return [];
      }

      const dataArr = [];

      const ltvList = this.analysisData.ltvList;

      this.analysisData.dataList.forEach(item => {
        const [date, people, ...valueList] = item.summary;
        const parentRow = {
          date: item.eventChineseName,
          people,
          children: [],
        };
        ltvList.forEach((l, idx) => {
          parentRow[l] = valueList[idx];
        });
        dataArr.push(parentRow);

        item.details.forEach(dateRowArr => {
          const [dateSub, peopleSub, ...valueListSub] = dateRowArr;
          const row = {
            date: dateSub,
            people: peopleSub,
          };
          ltvList.forEach((l, idx) => {
            row[l] = valueListSub[idx];
          });

          parentRow.children.push(row);
        });
      });

      return dataArr;
    },
    generatedColumn() {
      const currColumns = this.getBaseColumns();

      const { analysisData } = this;
      if (!analysisData || !analysisData.ltvList) {
        return currColumns;
      }

      analysisData.ltvList.forEach(item => {
        currColumns.push({
          colKey: item,
          title: item,
          // width: 140,
          cell: (h, context) => {
            const { col, row } = context;
            return row[col.colKey] ? row[col.colKey].toLocaleString() : '-';
          },
        });
      });

      return currColumns;
    },
    getBaseColumns() {
      return [
        {
          colKey: 'date',
          title: '事件/日期',
          // width: 140,
        },
        {
          colKey: 'people',
          title: '用户数',
          // width: 120,
          cell: (h, { row: { people } }) => {
            return people ? people.toLocaleString() : '-';
          },
        },
      ];
    },
    exportData() {
      const fileName = 'LTV分析结果.xlsx';
      const data = [];
      const headerArr = this.columns.map(i => i.title);
      data.push(headerArr);
      this.data.forEach(item => {
        const rowArr = [];
        this.columns.forEach(col => {
          rowArr.push(item[col.colKey]);
        });
        data.push(rowArr);
        if (Array.isArray(item.children)) {
          item.children.forEach(subItem => {
            const subRowArr = [];
            this.columns.forEach(col => {
              subRowArr.push(
                col.colKey === 'date' ? `${item[col.colKey]}-${subItem[col.colKey]}` : subItem[col.colKey],
              );
            });
            data.push(subRowArr);
          });
        }
      });
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'LTV分析数据');
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>

<style scoped lang="less">
.ltv-analysis-table-cont {
  flex: 1;
  overflow: auto;
}
</style>
